import React, {useEffect} from "react";

import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";

import Carousel from "../../../../General/components/Carousel/Carousel";
import MentorCarouselCard from "../MentorCarouselCard/MentorCarouselCard";
import MentorPlaceholder from "../../../../Mentor/components/MentorPlaceholder/MentorPlaceholder";
import {useBreakpoint} from "../../utils/useBreakpoint";
import {BuddyField} from "../../../../../types/generated";
import {useUniversity} from "../../../../../widgets/modules/UniversityProvider/UniversityProvider";
import {
    getNumberOfSlides,
    Slide,
    GlobalStyles,
    StyledLoadingCarouselContainer,
    StyledCarouselContainer,
} from "./MentorCarousel";

type StaffMentorCarouselProps = {
    loading: boolean;
    mentors: BuddyField[];
    onChatNow: (mentorId: string, cardPosition?: number) => void;
};

export function StaffMentorCarousel({
    loading = true,
    mentors,
    onChatNow,
}: StaffMentorCarouselProps) {
    const {isSmall, isMedium, isLarge} = useBreakpoint();
    const loadingItems = new Array(getNumberOfSlides({isSmall, isMedium, isLarge})).fill(1);
    const {features} = useUniversity();
    const isShowCountryFlagEnabled = features.get("showCountryFlag");
    const {trackEvent} = useAnalytics();
    const {slug: universitySlug} = useUniversity();

    useEffect(() => {
        // Using in-line name as this event should be temporary
        trackEvent("Staff Carousel Loaded", {
            universitySlug,
        });
    }, [trackEvent, universitySlug]);

    if (loading) {
        return (
            <>
                <GlobalStyles />
                <StyledLoadingCarouselContainer>
                    {loadingItems.map((_, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Slide key={i}>
                            <MentorPlaceholder lines={3} />
                        </Slide>
                    ))}
                </StyledLoadingCarouselContainer>
            </>
        );
    }

    return (
        <>
            <GlobalStyles />
            <StyledCarouselContainer>
                <Carousel
                    dots={false}
                    slidesToScroll={1}
                    slidesToShow={getNumberOfSlides({
                        isSmall,
                        isMedium,
                        isLarge,
                    })}
                >
                    {mentors.map((mentor: BuddyField, index: number) => (
                        <Slide key={mentor.id}>
                            <MentorCarouselCard
                                index={index}
                                onChatNow={onChatNow}
                                profilePhoto={mentor.profilePhoto}
                                mentorId={mentor.id}
                                firstName={mentor.firstName}
                                degreeName=""
                                degreeLevel=""
                                placeLabel=""
                                countryCode=""
                                primaryFlag=""
                                secondaryFlag=""
                                languages={[]}
                                year=""
                                lastSeen={null}
                                isExternal
                                isShowCountryFlagEnabled={isShowCountryFlagEnabled}
                                style={isSmall && !isMedium && !isLarge && {maxWidth: "300px"}}
                            />
                        </Slide>
                    ))}
                </Carousel>
            </StyledCarouselContainer>
        </>
    );
}
